{
    "name": "Medusa Pepper",
    "binomial_name": "Capsicum annuum",
    "common_names": [
        "medusa pepper",
        "christmas pepper"
    ],
    "description": "Medusa peppers are an ornamental Capsicum annuum cultivar that produces 40-50 upright, twisted fruit that look like Medusa's twisted hair of snakes. Fruit are 5.1cm long, slightly curved, and ripen from green to ivory, yellow, orange, and red. Unlike many other ornamental peppers, Medusa peppers are very mild and sweet, with a Scoville rating of 1-1000 units. Plants are compact and grow well in containers.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 0,
    "row_spacing": 90,
    "height": 40,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/medusa-pepper.jpg",
    "icon": "/crops/icons/medusa-pepper.avif"
}